import React, { Suspense, lazy } from 'react'
import { Modal } from '@web/walter-ui-kit'
import { useModal } from '~contexts/ModalsContext'
import { ModalTypes } from '~contexts/ModalsContext/types'
import SuspenseLoader from '~components/SuspenseLoader'

const Content = lazy(() => import('./Content'))

/**
 * AssetLimitsModal
 */
function AssetLimitsModal() {
    const { isOpen, hide } = useModal(ModalTypes.assetLimits)

    return (
        <Modal withHeaderBorder={false} isOpen={isOpen} onClose={hide} dataPointer="asset_limits_modal">
            <Suspense fallback={<SuspenseLoader type="modal" />}>
                <Content />
            </Suspense>
        </Modal>
    )
}

export default AssetLimitsModal
